










































































































































































import { Component, Vue } from "vue-property-decorator";
import { Button, Toast, Empty } from "vant";

@Component({
  components: {
    [Button.name]: Button,
    [Empty.name]: Empty
  }
})
export default class TransferIntoAbroad extends Vue {
  bankInfo: any = {};
  requestFail = false;
  IMG_NET_ERR = (this as any).IMG_NET_ERR;

  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

  get copyText() {
    return this.$t("funds.into.others[0]");
  }

  created() {
    this.$route.query.id && this.getBankInfoDetail();
  }

  /**
   * 获取银行卡对应的账户信息
   */
  getBankInfoDetail() {
    (this as any).$apis
      .getRemittanceDetail({ id: this.$route.query.id })
      .then(res => {
        this.requestFail = false;
        this.bankInfo = res;
      })
      .catch(() => {
        this.requestFail = true;
      });
  }

  /**
   * 复制成功回调
   */
  onCopySuccess() {
    Toast(this.$t("funds.into.others[6]"));
  }

  /**
   * 跳转到上传凭证
   */
  handleButtonClick() {
    this.$router.push({
      name: "credentials-upload",
      query: { ...this.$route.query }
    });
  }
}
